<template>
    <div class="error">
        <i-tooltip :disabled="!isBlankLayout">
            <div class="icon _text-danger" @click="onIconClick"><i-icon icon="danger" /></div>
            <div slot="body">
                <div v-if="$route.query.msgUnsupported">{{ $route.query.msgUnsupported }}</div>
                <div v-else>{{ $t("msgUnsupportedPre") }} <strong>{{ organizationName }}</strong> {{ $t("msgUnsupportedPost") }}</div>
            </div>
        </i-tooltip>

        <div class="message" v-if="$route.query.msgUnsupported">{{ $route.query.msgUnsupported }}</div>
        <div class="message" v-else>{{ $t("msgUnsupportedPre") }} <strong>{{ organizationName }}</strong> {{ $t("msgUnsupportedPost") }}</div>

        <ul class="list -inline _margin-0">
            <li>
                <a @click="$store.dispatch('reset')">{{ $t('tryAnother') }}</a>
            </li>
            <li class="_text-muted">
                &middot;
            </li>
            <li>
                <a :href="failedLink" target="_blank">{{msgFailedLink}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import StatusComponentMixin from "../../mixins/StatusComponentMixin";
import {
    IIcon
} from '@inkline/inkline/src/components';

export default {
    name: 'Unsupported',
    components: { IIcon },
    mixins: [
        StatusComponentMixin
    ],
    computed: {
        failedLink() {
            return this.$route.query.failedLink || this.$store.getters.organization?.website;
        },
        msgFailedLink() {
            return this.$route.query.msgFailedLink || this.$t("msgFailedLink");
        }
    }
};
</script>
